import clsx from 'clsx';
import { FC } from 'react';
import sanitizeHtml from '~/utils/sanitize-html';

import styles from './styles.module.css';

interface Props {
  html: TrustedHTML | string;
  className?: string;
}

const WYSIWYGContent: FC<Props> = ({ html, className }) => {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html as unknown as string) }}
      className={clsx(styles.description, className)}
    />
  );
};

export default WYSIWYGContent;
